import { render, staticRenderFns } from "./CodeForm.vue?vue&type=template&id=63e6fb50"
import script from "./CodeForm.vue?vue&type=script&lang=js"
export * from "./CodeForm.vue?vue&type=script&lang=js"
import style0 from "./CodeForm.vue?vue&type=style&index=0&id=63e6fb50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports